import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

import CreateFormInput from "../components/CreateFormInput";
import { isStringEmpty, isArrayEmpty } from "../utils/helpers";
import { saveFormToDB } from "../utils/backend";

const CreateForm = () => {
  const history = useHistory();

  const [saving, setSaving] = useState(false);
  const [formTitle, setFormTitle] = useState("");
  const [formDescription, setFormDescription] = useState("");
  const [questions, setQuestions] = useState([
    {
      title: "",
      type: "text",
      checkboxOptions: [""],
      radioOptions: [""],
    },
  ]);

  const setQuestionInfo = (index, type, value) => {
    const updatedQues = [...questions];
    updatedQues[index][type] = value;
    setQuestions(updatedQues);
  };

  const addQuestion = () => {
    const updatedQues = [
      ...questions,
      {
        title: "",
        type: "text",
        checkboxOptions: [""],
        radioOptions: [""],
      },
    ];
    setQuestions(updatedQues);
  };

  const deleteQuestion = (index) => {
    const updatedQues = questions.filter((q, i) => i !== index);
    setQuestions(updatedQues);
  };

  const updateOption = (index, type, optionIndex, value) => {
    const updatedQues = [...questions];
    updatedQues[index][type][optionIndex] = value;
    setQuestions(updatedQues);
  };

  const addOption = (index, type) => {
    const updatedQues = [...questions];
    updatedQues[index][type] = [...updatedQues[index][type], ""];
    setQuestions(updatedQues);
  };

  const saveForm = async () => {
    setSaving(true);

    const formQuestions = questions
      .filter((question) => !isStringEmpty(question.title))
      .map((question) => {
        const quesInfo = {
          questionTitle: question.title,
          questionType: question.type,
        };

        if (question.type === "checkbox" || question.type === "radioButton") {
          quesInfo["options"] =
            question.type === "checkbox"
              ? question.checkboxOptions.filter((option) => option !== "")
              : question.radioOptions.filter((option) => option !== "");
        }

        return quesInfo;
      });

    const data = {
      title: formTitle.trim(),
      description: formDescription.trim(),
      questions: formQuestions,
    };

    // basic validation for emptiness of any fields
    if (
      isStringEmpty(data.title) ||
      isStringEmpty(data.description) ||
      isArrayEmpty(data.questions)
    ) {
      setSaving(false);
      toast.info("Form is incomplete");
      return;
    }

    try {
      await saveFormToDB(data);
      setSaving(false);
      toast.success("Form created successfully");
      history.replace("/");
    } catch (error) {
      setSaving(false);
      console.error("an error occurred ", error);
      toast.error("Something went wrong: " + error.response.data);
    }
  };

  return (
    <form className="container my-4">
      <input
        type="text"
        value={formTitle}
        className="form-control col-md-10 form-control-lg my-2 mx-auto"
        placeholder="Form Title"
        onChange={(event) => setFormTitle(event.target.value)}
      ></input>
      <textarea
        value={formDescription}
        className="form-control col-md-10 my-2 mx-auto"
        rows="5"
        placeholder="Form Description"
        onChange={(event) => setFormDescription(event.target.value)}
      ></textarea>

      <div className="mt-4 mx-auto col-md-10 border">
        {questions.map((question, i) => (
          <CreateFormInput
            key={i}
            index={i}
            {...question}
            setQuestionInfo={setQuestionInfo}
            deleteQuestion={deleteQuestion}
            updateOption={updateOption}
            addOption={addOption}
          />
        ))}
        <div
          className="btn btn-primary btn-block col-8 mx-auto mb-3"
          onClick={addQuestion}
        >
          Add Question
        </div>
      </div>

      <div
        className="btn btn-success btn-block col-10 mt-4 mx-auto px-1 py-2 w-75"
        onClick={saveForm}
      >
        {saving ? "Saving. Please Wait ..." : "Save Form"}
      </div>
    </form>
  );
};

export default CreateForm;
